import React from 'react';
import { twMerge } from 'tailwind-merge';

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string;
  strokeWidth?: number;
  viewBox?: string;
  height?: number | string;
  width?: number | string;
}

export const Icon: React.FC<IconProps & { children: React.ReactNode }> = ({
  size = 16,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
  viewBox = '0 0 16 16',
  children,
  height,
  width,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || size}
      height={height || size}
      viewBox={viewBox}
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={twMerge('stroke-grey-500', className)}
      {...props}
    >
      {children}
    </svg>
  );
};
